import { EstadosSolicitudEnumChoice } from "@/shared/constants";
import { IFactibilidadCorporativo } from "../factibilidad_corporativo";

export type ISolicitudCanjeResp = {
  count: number;
  numero_paginas: number | undefined;
  next: string | undefined;
  previous: string | undefined;
  data: ISolicitudCanje[];
}

export type ISolicitudCanje = {
  id_solicitud_canje: string;
  estado: boolean;
  codigo: string;
  numero_referencia: string;
  motivo: string;
  motivo_rechazo: string;
  deuda: string;
  razon_social: string;
  identificacion: string;
  coordenadas: string;
  direccion: string;
  capacidad: number;
  nombre_contacto: string;
  numero_contacto: string;
  requiere_inspeccion: boolean;
  requiere_cotizacion: boolean;
  requiere_fibra_oscura: boolean;
  observaciones: any; // Aquí se puede modificar el tipo si se sabe más sobre el contenido de "observaciones"
  servicio: string | null;
  estado_solicitud: EstadosSolicitudEnumChoice; // Se pueden agregar más estados según el contexto
  factibilidad: string;
  factibilidad_data?: IFactibilidadCorporativo
  factibilidad_corporativa_data?:IFactibilidadCorporativo
  ciudad: string;
  provincia: string;
  user_create?: string;
  empresa_create?: string;
  area_create?: string;
  departamento_create?: string;
  canal_venta_create?: string;
  canje_aplicado?:boolean;
  preventa_coorporativa?: string;
  fecha_creacion: Date;
}

export type ISolicitudCanjeParams = Partial<ISolicitudCanje> & {
  page?: number
  page_size?: number
}

export enum TipoSolicitudesEnum {
  EVENTO = "EVENTO",
  CANJE = "CANJE",
  EVENTO_GRATUITO = "EVENTO GRATUITO",
  EVENTO_PAGADO = "EVENTO PAGADO",
  HOGAR = 'HOGAR',
  PYMES = 'PYMES'
}

export const TipoSolicitudesEnumChoice = [
  TipoSolicitudesEnum.CANJE,
  TipoSolicitudesEnum.EVENTO,
]

export const TipoEventoEnumChoice = [
  TipoSolicitudesEnum.EVENTO_GRATUITO,
  // TipoSolicitudesEnum.EVENTO_PAGADO,
]